import { s } from '@/theme/tokens';
import { Section, Stack, Text } from '@/ui';
import { PolicyPageShell } from '@/ui/layout';
import { Box, Link } from '@/ui/primitives';
import type { ReactElement } from 'react';

export const PrivacyRequestsPage = (): ReactElement => (
  <PolicyPageShell>
    <Box
      sx={{
        maxWidth: '960px',
        marginX: 'auto',
        paddingX: s('lg'),
        paddingY: s('xl'),
      }}
    >
      <Stack gap="xl">
        <Section>
          <Stack gap="sm">
            <Text role="pageTitle">Privacy Requests</Text>
            <Text role="body">
              If you would like to access, correct, or delete your personal data, please contact us
              at <Link href="mailto:support@flowqa.com">support@flowqa.com</Link>.
            </Text>
          </Stack>
        </Section>
      </Stack>
    </Box>
  </PolicyPageShell>
);
